import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import * as timeago from "timeago.js"
import { format } from "timeago.js"
import fr from "timeago.js/lib/lang/fr"
import en from "timeago.js/lib/lang/en_US"
import { Helmet } from "react-helmet"
// Components
import Navbar from "../../components/Navbar/Navbar"
import Footer from "../../components/Footer/Footer"
import Checkbox from "../../components/Checkbox/Checkbox"
// Styles
import {
   Column,
   Container,
   Display,
   Header,
   Info,
   InfoItem,
   InfoLabel,
   Title,
   Wrapper,
   StyledLink,
} from "./ServiceRequest.styles"

const ServiceRequest = () => {
   timeago.register("fr", fr)
   timeago.register("en", en)
   const location = useLocation()
   const { t } = useTranslation()
   const language = useSelector((state) => state.environment.language)
   const requestId = location.pathname.split("/")[2]
   const request = useSelector((state) =>
      state.service.requests.find(
         (request) => request._id.toString() === requestId
      )
   )

   const sparePartTranslations = {
      full: t("serviceRequests.value.sparePart.s1"),
      temples: t("serviceRequests.value.sparePart.s2"),
      left: t("serviceRequests.value.sparePart.s3"),
      right: t("serviceRequests.value.sparePart.s4"),
      endtips: t("serviceRequests.value.sparePart.s5"),
      nosepads: t("serviceRequests.value.sparePart.s6"),
   }

   const formatDate = (date, language) => {
      if (!date) return ""
      return format(date, language)
   }
   return (
      <>
         <Helmet>
            <title>{t("serviceRequestPage.meta.meta_title")}</title>
            <meta name="robots" content="noindex, nofollow" />
         </Helmet>
         <Container>
            <Navbar bgImageColor="light" />
            <Wrapper>
               <Header>
                  <Title>
                     {t("serviceRequestPage.title.t1")} RQ-SV
                     {request.requestNumber}
                  </Title>
                  <Display>
                     <Column>
                        <InfoItem>
                           <InfoLabel>
                              {t("serviceRequestPage.label.l1")} :
                           </InfoLabel>
                           <Info>{format(request.requestDate, language)}</Info>
                        </InfoItem>
                        <InfoItem>
                           <InfoLabel>
                              {t("serviceRequestPage.label.l2")} :
                           </InfoLabel>
                           <Info>{request.productRef}</Info>
                        </InfoItem>
                        <InfoItem>
                           <InfoLabel>
                              {t("serviceRequestPage.label.l3")} :
                           </InfoLabel>
                           <Info>
                              {sparePartTranslations[request.sparePart]}
                           </Info>
                        </InfoItem>
                        <InfoItem>
                           <InfoLabel>
                              {t("serviceRequestPage.label.l4")} :
                           </InfoLabel>
                           <Info>{request.comments}</Info>
                        </InfoItem>
                     </Column>
                     <Column>
                        <InfoItem>
                           <InfoLabel>
                              {t("serviceRequestPage.label.l5")} :
                           </InfoLabel>
                           <Checkbox
                              defaultChecked={request.replacementSent}
                              readOnly={true}
                           />
                        </InfoItem>
                        <InfoItem>
                           <InfoLabel>
                              {t("serviceRequestPage.label.l6")} :
                           </InfoLabel>
                           <Info>
                              {formatDate(
                                 request.dateReplacementShipped,
                                 language
                              )}
                           </Info>
                        </InfoItem>
                        {request.carrierUrl ? (
                           <StyledLink to={request.carrierUrl}>
                              <InfoItem>
                                 <InfoLabel>
                                    {t("serviceRequestPage.label.l7")} :
                                 </InfoLabel>
                                 <Info>{request.carrierUrl}</Info>
                              </InfoItem>
                           </StyledLink>
                        ) : (
                           <InfoItem>
                              <InfoLabel>
                                 {t("serviceRequestPage.label.l7")} :
                              </InfoLabel>
                              <Info>{request.carrierUrl}</Info>
                           </InfoItem>
                        )}
                     </Column>
                     <Column>
                        <InfoItem>
                           <InfoLabel>
                              {t("serviceRequestPage.label.l8")} :
                           </InfoLabel>
                           <Checkbox
                              defaultChecked={request.returnOk}
                              readOnly={true}
                           />
                        </InfoItem>
                        <InfoItem>
                           <InfoLabel>
                              {t("serviceRequestPage.label.l9")} :
                           </InfoLabel>
                           <Info>
                              {formatDate(request.dateReturnReceived, language)}
                           </Info>
                        </InfoItem>
                     </Column>
                  </Display>
               </Header>
            </Wrapper>
            <Footer />
         </Container>
      </>
   )
}

export default ServiceRequest
